import { clsx } from 'clsx';
import React from 'react';
import classes from './Breadcrumbs.module.css.js';
import { toggleSxComponent } from '../internal/utils/toggleSxComponent.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SELECTED_CLASS = 'selected';
const BreadcrumbsList = ({
  children
}) => {
  return /*#__PURE__*/React.createElement("ol", {
    className: classes.BreadcrumbsList
  }, children);
};
BreadcrumbsList.displayName = "BreadcrumbsList";
const BreadcrumbsBaseComponent = toggleSxComponent('nav');
function Breadcrumbs({
  className,
  children,
  sx: sxProp
}) {
  const wrappedChildren = React.Children.map(children, child => /*#__PURE__*/React.createElement("li", {
    className: classes.ItemWrapper
  }, child));
  return /*#__PURE__*/React.createElement(BreadcrumbsBaseComponent, {
    className: clsx(className, classes.BreadcrumbsBase),
    "aria-label": "Breadcrumbs",
    sx: sxProp
  }, /*#__PURE__*/React.createElement(BreadcrumbsList, null, wrappedChildren));
}
Breadcrumbs.displayName = "Breadcrumbs";
const BreadcrumbsItemBaseComponent = toggleSxComponent('a');
const BreadcrumbsItem = /*#__PURE__*/React.forwardRef(({
  selected,
  className,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(BreadcrumbsItemBaseComponent, _extends({
    className: clsx(className, classes.Item, {
      [SELECTED_CLASS]: selected,
      [classes.ItemSelected]: selected
    }),
    "aria-current": selected ? 'page' : undefined,
    ref: ref
  }, rest));
});
Breadcrumbs.displayName = 'Breadcrumbs';
BreadcrumbsItem.displayName = 'Breadcrumbs.Item';
var Breadcrumbs$1 = Object.assign(Breadcrumbs, {
  Item: BreadcrumbsItem
});

/**
 * @deprecated Use the `Breadcrumbs` component instead (i.e. `<Breadcrumb>` → `<Breadcrumbs>`)
 */
const Breadcrumb = Object.assign(Breadcrumbs, {
  Item: BreadcrumbsItem
});

/**
 * @deprecated Use the `BreadcrumbsProps` type instead
 */

/**
 * @deprecated Use the `BreadcrumbsItemProps` type instead
 */

export { Breadcrumb, Breadcrumbs$1 as default };
